// Event name and property-key constants. No inline string literals for event names elsewhere.

export const EVENTS = {
  // Identity & lifecycle
  USER_LOGGED_IN: "user_logged_in",
  USER_LOGGED_OUT: "user_logged_out",
  SESSION_IDLE_TIMEOUT: "session_idle_timeout",

  // Control state changes (controlTracking.js)
  CONTROL_TOGGLED: "control_toggled", // switch: state on|off
  CHECKBOX_CHANGED: "checkbox_changed", // checked true|false
  RADIO_SELECTED: "radio_selected",
  FIELD_CHANGED: "field_changed", // text box / textarea / native select, on commit (blur)

  // Impersonation
  IMPERSONATION_BLOCKED: "impersonation_blocked",
  IMPERSONATION_STARTED: "impersonation_started",
  IMPERSONATION_STARTED_TARGET: "impersonation_started_target",
  IMPERSONATION_ENDED: "impersonation_ended",

  // Business events
  INVENTORY_UPLOADED: "inventory_uploaded",
  INVENTORY_ITEM_CREATED: "inventory_item_created",
  INVENTORY_ITEM_EDITED: "inventory_item_edited",
  INVENTORY_ITEM_DELETED: "inventory_item_deleted",
  CATALOG_SEARCH_PERFORMED: "catalog_search_performed",
  PRODUCT_VIEWED: "product_viewed",
  BUILDER_OPENED: "builder_opened",
  PO_CREATED: "po_created",
  PO_STATUS_CHANGED: "po_status_changed",
  VENDOR_CONNECTION_REQUESTED: "vendor_connection_requested",
  VENDOR_CONNECTION_APPROVED: "vendor_connection_approved",
  VENDOR_CONNECTION_REJECTED: "vendor_connection_rejected",
  ADMIN_SETTING_CHANGED: "admin_setting_changed",
  APPLICATION_PERMISSION_CHANGED: "application_permission_changed",
  DEALER_LIMIT_CREATED: "dealer_limit_created",
  DEALER_LIMIT_DELETED: "dealer_limit_deleted",

  // System
  API_ERROR_OCCURRED: "api_error_occurred",
};
